var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBranchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#ABBED0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.67 4.21a2.585 2.585 0 1 1-5.17 0 2.585 2.585 0 0 1 5.17 0zM10.143 6.794h5.17V1.625h-5.17zM10.143 15.41h5.17v-5.169h-5.17zM10.116 4.21H6.67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.116 12.826h-2.43a3.602 3.602 0 0 1-3.601-3.602v-2.43"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranchIcon);
export default __webpack_public_path__ + "static/media/branch-icon.2e40d8a5.svg";
export { ForwardRef as ReactComponent };